import { Component } from '@angular/core';
import { LoginVm } from '../../Model/LoginVM';
import { DownloadService } from '../../Services/download.service';
import { CustomToastrService } from '../../Shared/Services/custom-toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../Shared/Services/shared.service';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrl: './download.component.scss'
})
export class DownloadComponent {
  currentUser: LoginVm = {};
  polywinSector = null;
  kemetwinSector = 16;
  constructor(private download: DownloadService,
    private toastrService: CustomToastrService, private shared: SharedService,
    private spinner: NgxSpinnerService) {
  }

  DownloadAccessoriesPrices(sectorId: number | null) {
    this.spinner.show();
    this.download.DownloadAccessoriesPrices(sectorId)
      .subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            this.shared.downloadBlobFile(data, 'AccessoriesPrices');
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }

  DownloadSectorPrices(sectorId: number | null) {
    this.spinner.show();
    this.download.DownloadSectorPrices(sectorId)
      .subscribe(
        {
          next: (data: any) => {
            this.spinner.hide();
            this.shared.downloadBlobFile(data, 'SectorPrices');
          },
          error: (error: any) => {
            this.spinner.hide();
            this.toastrService.showErrorToast('Error', "SomethingWentWrong");
          }
        });
  }
}
